import PageHero from '@/components/feature/PageHero';
import SupplierSurvey from '@/components/feature/SupplierSurvey';

export default function SupplierInsights() {
  return (
    <>
      <PageHero
        eyebrow="Supplier Research"
        title="KOR38 Supplier Insights Survey"
        intro={
          <>
            <p className="font-label text-sm uppercase tracking-[0.14em] text-accent-600">
              Help shape a better way for event suppliers to receive relevant, qualified
              introductions.
            </p>
            <p>
              We&rsquo;d love to understand how event suppliers find customers, manage enquiries and
              work with referral partners. Your answers will help us learn what really matters to
              businesses like yours.
            </p>
          </>
        }
      />

      <section className="w-full px-4 md:px-8 lg:px-12 pb-20 md:pb-28 bg-background-50">
        <div className="max-w-2xl mx-auto">
          <div className="mb-8 flex flex-wrap items-center gap-x-7 gap-y-3 rounded-lg border border-background-200 bg-background-100 px-5 py-4">
            <span className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-question-line text-primary-400" aria-hidden="true"></i>
              10 core questions
            </span>
            <span className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-time-line text-primary-400" aria-hidden="true"></i>
              Approximately 3 minutes
            </span>
            <span className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-lock-line text-primary-400" aria-hidden="true"></i>
              Contact details optional
            </span>
          </div>

          <SupplierSurvey />
        </div>
      </section>
    </>
  );
}